import { z } from 'zod'
import { pageSchema } from './page'
import { productPreviewSchema } from './product'

export const favouritesSchema = z.object({
  products: z.array(productPreviewSchema),
  pages: z.array(
    pageSchema.omit({
      templateAlias: true,
    }),
  ),
})
